import React, { useState, useEffect } from 'react';

import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Modal from '@salesforce/design-system-react/components/modal';
import Button from '@salesforce/design-system-react/components/button';
import Combobox from '@salesforce/design-system-react/components/combobox';
import ColorPicker from '@salesforce/design-system-react/components/color-picker';
import Textarea from '@salesforce/design-system-react/components/textarea';
import Input from '@salesforce/design-system-react/components/input';

const leadSourceOptions = [
  { id: `${Math.random() * 1000000}`, label: 'Third Party Program', value: 'A0' },
  { id: `${Math.random() * 1000000}`, label: 'Cold Call', value: 'B0' },
  { id: `${Math.random() * 1000000}`, label: 'LinkedIn', value: 'C0' },
  { id: `${Math.random() * 1000000}`, label: 'Direct Mail', value: 'D0' },
  { id: `${Math.random() * 1000000}`, label: 'Other', value: 'E0' },
];

const AddClient = (props) => {
  const { openModal, closeModal, handleFormSubmit } = props;
  const [categorySelection, setCategorySelection] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setIsOpen(openModal);
  }, [openModal]);

  const toggleOpen = () => {
    closeModal();
  };

  const handleSaveClick = () => {
    if (!formData.accountName || !formData.accountAddress)
      return alert('Please enter account name and address!');
    if (categorySelection.length) formData.category = categorySelection[0].value;
    handleFormSubmit(formData);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        footer={[
          <Button key={'cancel'} label="Cancel" onClick={toggleOpen} />,
          <Button key="save" label="Save" onClick={handleSaveClick} variant="brand" />,
        ]}
        onRequestClose={toggleOpen}
        heading="Add New Client"
      >
        <section className="slds-p-around_large">
          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="slds-col_padded slds-m-bottom_large">
              <Input
                id="firstName"
                name="firstName"
                label="First Name"
                required
                placeholder="Enter First Name"
                value={formData.firstName || ''}
                onChange={handleInputChange}
              />
            </div>
            <div className="slds-col_padded slds-m-bottom_large">
              <Input
                id="lastName"
                name="lastName"
                label="Last Name"
                required
                placeholder="Enter Last Name"
                value={formData.lastName || ''}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="slds-col_padded slds-m-bottom_large">
              <Input
                id="phoneNumber"
                name="phoneNumber"
                label="Phone"
                required
                placeholder="(+1) 123 456 7890"
                value={formData.fieldLabel || ''}
                onChange={handleInputChange}
              />
            </div>
            <div className="slds-col_padded slds-m-bottom_large">
              <Input
                id="emailAddress"
                name="emailAddress"
                label="Email Address"
                required
                placeholder="johndoe@example.com"
                value={formData.emailAddress || ''}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="slds-col_padded slds-m-bottom_large">
              <IconSettings iconPath="/assets/icons">
                <Combobox
                  events={{
                    onSelect: (event, data) => {
                      const selection =
                        data.selection.length === 0 ? categorySelection : data.selection;
                      setCategorySelection(selection);
                    },
                  }}
                  labels={{
                    label: 'Category',
                    placeholder: 'Select Category',
                  }}
                  options={leadSourceOptions}
                  selection={categorySelection}
                  variant="readonly"
                  required
                />
              </IconSettings>
            </div>
            <div className="slds-col_padded slds-m-bottom_large">
              <IconSettings iconPath="/assets/icons">
                <Combobox
                  events={{
                    onSelect: (event, data) => {
                      const selection =
                        data.selection.length === 0 ? categorySelection : data.selection;
                      setCategorySelection(selection);
                    },
                  }}
                  labels={{
                    label: 'Type',
                    placeholder: 'Select Type',
                  }}
                  options={leadSourceOptions}
                  selection={categorySelection}
                  variant="readonly"
                  required
                />
              </IconSettings>
            </div>
          </div>
          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="slds-col_padded slds-m-bottom_large">
              <IconSettings iconPath="/assets/icons">
                <Combobox
                  events={{
                    onSelect: (event, data) => {
                      const selection =
                        data.selection.length === 0 ? categorySelection : data.selection;
                      setCategorySelection(selection);
                    },
                  }}
                  labels={{
                    label: 'Field Label',
                    placeholder: 'Select Field label',
                  }}
                  options={leadSourceOptions}
                  selection={categorySelection}
                  variant="readonly"
                  required
                />
              </IconSettings>
            </div>
            <div className="slds-col_padded slds-m-bottom_large">
              <IconSettings iconPath="/assets/icons">
                <Combobox
                  events={{
                    onSelect: (event, data) => {
                      const selection =
                        data.selection.length === 0 ? categorySelection : data.selection;
                      setCategorySelection(selection);
                    },
                  }}
                  labels={{
                    label: 'Lead Source',
                    placeholder: 'Select Lead Source',
                  }}
                  options={leadSourceOptions}
                  selection={categorySelection}
                  variant="readonly"
                  required
                />
              </IconSettings>
            </div>
          </div>

          <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
            <div className="slds-col_padded" style={{ alignSelf: 'normal' }}>
              <div className="slds-form-element">
                <div className="slds-form-element__control">
                  <Textarea
                    id="description"
                    name="description"
                    label="Description"
                    placeholder="Enter description"
                    value={formData.description || ''}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
            <div className="slds-col_padded">
              <div className=" slds-m-bottom_large">
                <Input
                  id="tags"
                  name="tags"
                  label="Tags"
                  value={formData.tags || ''}
                  onChange={handleInputChange}
                  placeholder="Trading,Skating,Tomb"
                />
                <div className="slds-m-top_medium">
                  <IconSettings iconPath="/assets/icons">
                    <ColorPicker
                      labels={{ label: 'Color' }}
                      id="color"
                      name="color"
                      menuPosition="overflowBoundaryElement"
                      value=""
                      events={{
                        onChange: (event, { color }) => {
                          setFormData({
                            ...formData,
                            color,
                          });
                        },
                      }}
                    />
                  </IconSettings>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Modal>
    </div>
  );
};

export default AddClient;
